import { CartOrigin } from '@/types/enums/analytics/cart/cart-analytics.enum';
import { getEntityProfileType } from '@/utils/entity/get-entity-profile-type.util';

export function getCartOrigin(pathname: string | null | undefined): CartOrigin {
  if (!pathname) {
    return CartOrigin.OTHER;
  }

  if (pathname.startsWith('/busca/')) {
    return CartOrigin.SEARCH_RESULTS;
  }

  if (getEntityProfileType(pathname)) {
    return CartOrigin.PROFILE;
  }

  if (pathname.startsWith('/agendamentos')) {
    return CartOrigin.APPOINTMENTS;
  }

  if (pathname === '/' || pathname.startsWith('/cidades/')) {
    return CartOrigin.HOME;
  }

  return CartOrigin.OTHER;
}
